import { Tooltip } from '@heroui/react';
import { DateTime } from 'luxon';
import React from 'react';
import { FiInfo } from 'react-icons/fi';

import { TransmissionEventRowProps } from '../types';

import { MetaDataTable } from './MetaDataTable';
import { NewStateIndicator } from './NewStateIndicator';

const getTimestampDelta = (
  timestamp: string,
  orderCreatedAt?: number
): string => {
  if (!orderCreatedAt) return '';

  const eventTime = DateTime.fromISO(timestamp);
  const orderTime = DateTime.fromMillis(orderCreatedAt);
  const diff = eventTime.diff(orderTime, ['hours', 'minutes', 'seconds']);

  return `+ ${diff.toFormat('hh:mm:ss')}`;
};

export const TransmissionEventRow: React.FC<TransmissionEventRowProps> = ({
  transmissionEvent,
  orderCreatedAt,
}) => {
  const { timestamp, metaData } = transmissionEvent;
  const formattedTimestamp = DateTime.fromISO(timestamp).toFormat(
    'yyyy-MM-dd HH:mm:ss'
  );
  const timestampDelta = getTimestampDelta(timestamp, orderCreatedAt);

  return (
    <div className="flex items-center gap-4 text-sm">
      {/* State Indicator */}
      <div className="w-32 flex-shrink-0">
        <NewStateIndicator transmissionEvent={transmissionEvent} />
      </div>

      {/* Timestamp */}
      <span className="text-foreground font-mono">{formattedTimestamp}</span>

      {/* Delta */}
      {timestampDelta && (
        <span className="text-default-500 font-mono">{timestampDelta}</span>
      )}

      {/* Metadata Info Icon */}
      {metaData && (
        <Tooltip
          content={<MetaDataTable metaData={metaData} />}
          placement="right"
          closeDelay={0}
          classNames={{
            content: 'p-0 max-w-md',
          }}
        >
          <button
            type="button"
            className="text-default-400 hover:text-default-600 transition-colors"
            aria-label="View metadata"
          >
            <FiInfo className="w-4 h-4" />
          </button>
        </Tooltip>
      )}
    </div>
  );
};
